import type { IconSvgElement } from '@hugeicons/react'
import {
  AudioWave01Icon as AudioWave01StrokeIcon,
  GlobalSearchIcon as GlobalSearchStrokeIcon,
  Image03Icon as Image03StrokeIcon,
  UserGroup03Icon as UserGroup03StrokeIcon,
  ModernTvIcon as ModernTvStrokeIcon,
  ShoppingCart01Icon as ShoppingCart01StrokeIcon,
} from '@hugeicons-pro/core-stroke-rounded'
import {
  AudioWave01Icon as AudioWave01SolidIcon,
  GlobalSearchIcon as GlobalSearchSolidIcon,
  Image03Icon as Image03SolidIcon,
  UserGroup03Icon as UserGroup03SolidIcon,
  ModernTvIcon as ModernTvSolidIcon,
  ShoppingCart01Icon as ShoppingCart01SolidIcon,
} from '@hugeicons-pro/core-solid-rounded'

export type ChannelKey = 'search' | 'social' | 'tv' | 'programmatic' | 'audio' | 'retail'

export const CHANNEL_ICONS_STROKE: Record<ChannelKey, IconSvgElement> = {
  search: GlobalSearchStrokeIcon,
  social: UserGroup03StrokeIcon,
  tv: ModernTvStrokeIcon,
  programmatic: Image03StrokeIcon,
  audio: AudioWave01StrokeIcon,
  retail: ShoppingCart01StrokeIcon,
}

export const CHANNEL_ICONS_SOLID: Record<ChannelKey, IconSvgElement> = {
  search: GlobalSearchSolidIcon,
  social: UserGroup03SolidIcon,
  tv: ModernTvSolidIcon,
  programmatic: Image03SolidIcon,
  audio: AudioWave01SolidIcon,
  retail: ShoppingCart01SolidIcon,
}

export function getChannelIconStroke(key: string): IconSvgElement | null {
  return (CHANNEL_ICONS_STROKE as Record<string, IconSvgElement>)[key] ?? null
}

export function getChannelIconSolid(key: string): IconSvgElement | null {
  return (CHANNEL_ICONS_SOLID as Record<string, IconSvgElement>)[key] ?? null
}
